"use strict";

/**
 * @ngdoc service
 * @name diceApp.factory:CancelButton
 * @description
 * The CancelButton service.
 */
angular.module("diceApp").directive("closeButton", function () {
  return {
    restrict: "E",
    scope: {
      btnType: "@?",
      btnSize: "@?",
      btnIconOnly: "=?",
      btnContext: "@?",
      type: "@?"
    },
    link: function (scope) {
      scope.btnContext = scope.btnContext || "default";
    },
    templateUrl: "es6/base/forms/buttons/close.button.html"
  };
});
